require('./tabs.scss');
const PropTypes = require('prop-types');
const React = require('react');
const { includes } = require('lodash/collection');
const className = require('classnames');

const myProfile = '/myprofile/';
const accountHiringRoutes = [
    `${myProfile}purchase/checking-account`,
    `${myProfile}purchase/junior-account`,
    `${myProfile}purchase/e-account-loan`,
    `${myProfile}purchase/payroll-account`,
    `${myProfile}hire/welcome-payroll-account`,
    `${myProfile}hire/welcome-account`,
    `${myProfile}hire/pack/open-young`,
];
const cardHiringRoutes = [
    `${myProfile}hire/card/diamond-pack`,
    `${myProfile}hire/card/premium-pack`,
    `${myProfile}hire/card/open-credit`,
    `${myProfile}hire/card/via-t`,
    `${myProfile}hire/card/open-young`,
    `${myProfile}hire/card/open-debit`,
    `${myProfile}hire/card/minicard`,
    `${myProfile}hire/card/solidarity`,
];
const depositHiringRoutes = [
    `${myProfile}purchase/deposit-thirteen-months`,
    `${myProfile}purchase/deposit-thirteen-months-renovacion-excepciones`,
    `${myProfile}purchase/deposit-thirteen-months-excepciones`,
    `${myProfile}purchase/deposit-eighteen-months-retention`,
    `${myProfile}purchase/combined-deposit`,
    `${myProfile}purchase/deposit-twentyfour-months-retention`,
    `${myProfile}purchase/deposit-eighteen-months`,
    `${myProfile}purchase/deposittransfer`,
    `${myProfile}purchase/depositnm`,
    `${myProfile}purchase/depositpayroll`,
    `${myProfile}purchase/deposit`,
];
const loanHiringRoutes = [
    `${myProfile}mortgage/panel`,
    `${myProfile}mortgage/pre-approval`,
    `${myProfile}loans-mortgages/pre-granted-credit`,
];

class Tabs extends React.Component {
    mapDropdown(linkTabSelected, dropdown) {
        let isDropdownSelected = false;

        for (let i = 0; i < dropdown.length; i++) {
            if (dropdown[i].hasOwnProperty('subitems')) {
                if (this.mapSubItems(linkTabSelected, dropdown[i].subitems)) {
                    isDropdownSelected = true;
                    break;
                }
            }

            if (!!dropdown[i].path && includes(linkTabSelected, dropdown[i].path)) {
                isDropdownSelected = true;
                break;
            }
        }

        return isDropdownSelected;
    }

    mapSubItems(linkTabSelected, subitems) {
        let isItemSelected = false;

        for (let i = 0; i < subitems.length; i++) {
            if (!!subitems[i].path && includes(linkTabSelected, subitems[i].path)) {
                isItemSelected = true;
                break;
            }
        }

        return isItemSelected;
    }

    getLinkContext(link) {
        let context = link;

        if (accountHiringRoutes.includes(link)) {
            context = '/myprofile/accounts';
        } else if (cardHiringRoutes.includes(link)) {
            context = '/myprofile/cards';
        } else if (depositHiringRoutes.includes(link)) {
            context = '/myprofile/deposits';
        } else if (loanHiringRoutes.includes(link)) {
            context = '/myprofile/loans-mortgages';
        }

        return context;
    }

    mapTabs(linkTabSelected, tab) {
        const context = this.getLinkContext(linkTabSelected);

        let isSelected = false;

        if (tab.props.hasOwnProperty('dropdown')) {
            if (!!tab.props.path && includes(context, tab.props.path)) {
                isSelected = true;
            } else {
                isSelected = this.mapDropdown(context, tab.props.dropdown)
            }
        }

        if (!isSelected){
            isSelected = includes(context, tab.props.link);
        }

        return isSelected;
    }

    render() {
        const { children, linkTabSelected, customClassName } = this.props;

        const tabsEl = children.map((tab, index) => {

            return React.cloneElement(tab, {
                    key: `tab-key-${index}`,
                    isSelected: this.mapTabs(linkTabSelected, tab)
                }
            )
        });
        const classNameComponent = className('ok-tabs', {
            [customClassName]: !!customClassName
        });

        return (
            <ul className={classNameComponent}>
                {tabsEl}
            </ul>
        );
    }
}

Tabs.propTypes = {
    children: PropTypes.array,
    customClassName: PropTypes.string,
    linkTabSelected: PropTypes.string,
    onClickTab: PropTypes.func
};

module.exports = Tabs;
